import{__exports as e}from"../../../../../_virtual/contract2.js";Object.defineProperty(e,"__esModule",{value:!0}),e.aggregate3Signature=void 0,e.aggregate3Signature="0x82ad56cb";export{e as default};
